/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
import { code } from 'codemash';
import { Config } from 'configs';
import { apiActionChooser } from 'utils/apiActionChooser';
import { manageFunctionResponse } from 'utils/errorHandler';
import { functionRequest } from './client/requests';

export const payRKeeperOrder = async ({ token, orderId, alertController }) => {
  try {
    const response = await code.executeFunction({
      secretKey: token,
      functionId: Config.DATA.FUNCTIONS.PAY_RKEEPER_ORDER,
      data: {
        token,
        orderId,
      },
    });

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not complete order' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to complete order', e);

    if (alertController) {
      alertController.error({ text: 'Could not complete order' });
    }
  }

  return null;
};

export const updateOrderFields = async ({
  companyId,
  token,
  orderId,
  fields,
  values,
  alertController,
}) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          secretKey: token,
          functionId: Config.DATA.FUNCTIONS.UPDATE_ORDER_FIELDS,
          data: {
            token,
            orderId,
            fields,
            values,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'UpdateOrderFields',
          data: JSON.stringify({
            orderId,
            fields,
            values,
          }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          if (managedResponse.message === 'delivery_cant_cancel') {
            alertController.error({
              text: 'Cannot cancel delivery anymore. Contact delivery provider to cancel the order.',
            });
          } else {
            alertController.error({ text: 'Could not update order' });
          }
        }
      }
    } else {
      return {
        ordersUpdateResponse: managedResponse.ordersUpdateResponse,
        syncedOrdersUpdateResponse: managedResponse.syncedOrdersUpdateResponse,
        needRefreshOrder: managedResponse.needRefreshOrder,
      };
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to update order', e);

    if (alertController) {
      alertController.error({ text: 'Could not update order' });
    }
  }

  return null;
};
